import { ACTIVATION_LABELS, REASON_LABELS, formatReasonLabel, resolveSupportLabel } from '../classification';
import type { ExplorationVolume } from '../../types/exploration';

const FOCUSED_REASON_KEY_BY_LABEL: Record<string, string> = {
  [ACTIVATION_LABELS.unsupported]: 'unsupported',
  [ACTIVATION_LABELS.potentiallySupported]: 'potentiallySupported',
};

const PENDING_REASON_LABELS: Record<string, string> = {
  agent_not_autoscaler: 'No Autoscaler',
  no_autoscaler: 'No Autoscaler',
};

export type FocusedReasonKey = 'unsupported' | 'potentiallySupported';

function pendingReasonKeyFor(v: ExplorationVolume): string {
  const reasons = Array.isArray(v.datafiableReasons) ? v.datafiableReasons : [];
  if (!reasons.length) return 'unknown';
  return reasons.find((r) => PENDING_REASON_LABELS[r] || REASON_LABELS[r]) || reasons[0];
}

function pendingReasonLabelFor(key: string): string {
  return PENDING_REASON_LABELS[key] || REASON_LABELS[key] || formatReasonLabel(key || '');
}

export function reasonLabelForVolume(
  v: ExplorationVolume,
  focusedKey: FocusedReasonKey | string
): string {
  if (focusedKey === 'potentiallySupported') {
    const k = pendingReasonKeyFor(v);
    return k === 'unknown' ? 'Unknown' : pendingReasonLabelFor(k);
  }
  const k = v.supportStatus;
  return resolveSupportLabel(k || '');
}

export function reasonKeyForVolume(
  v: ExplorationVolume,
  focusedKey: FocusedReasonKey | string
): string {
  if (focusedKey === 'potentiallySupported') return pendingReasonKeyFor(v);
  return v.supportStatus;
}

export function focusedKeyFromLabel(label: string): FocusedReasonKey | null {
  const key = FOCUSED_REASON_KEY_BY_LABEL[label];
  return key === 'unsupported' || key === 'potentiallySupported' ? key : null;
}
